const TOGGLE_TOP_GLOBAL_NAV_COLLAPSED = 'TOGGLE_TOP_GLOBAL_NAV_COLLAPSED';

export function actionToggleTopGlobalNav(payload) {
  return {
    type: TOGGLE_TOP_GLOBAL_NAV_COLLAPSED,
    payload,
  };
}

const intialGlobalInfo = {
  collapsed: false,
};

export default function topGlobalNav(state = intialGlobalInfo, action) {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_TOP_GLOBAL_NAV_COLLAPSED:
      return Object.assign({}, state, { collapsed: payload?.collapsed ?? !state.collapsed });
    default:
      return state;
  }
}
